(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gd-default-restock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gd-default-restock')) {
    customElements.define(
      'gd-default-restock',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          if (!this.form) return;
          this.plans = JSON.parse(this.querySelector('script').textContent);
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.update = () => {
            const external = this.form.elements.namedItem('selling_plan');
            const plan = this.plans[this.form.elements.namedItem('id')?.value];
            const note = this.querySelector('[data-restock-note]');
            note.hidden = !!external || !plan;
            if (plan) {
              const text = 'Auto-Restock: ' + plan.price + ' today';
              if (note.textContent !== text) note.textContent = text;
            }
          };
          // An existing selling_plan control is authoritative, even when its value is empty.
          this.form.addEventListener(
            'formdata',
            (event) => {
              if (this.form.elements.namedItem('selling_plan')) return;
              const plan = this.plans[event.formData.get('id')];
              if (plan) event.formData.set('selling_plan', String(plan.id));
            },
            options,
          );
          this.form.addEventListener('variant:changed', this.update, options);
          this.form.addEventListener('change', this.update, options);
          this.observer = new MutationObserver(this.update);
          this.observer.observe(this.form, { childList: true, subtree: true });
          this.update();
        }
        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-flavor-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gd-flavor-picker'))
    customElements.define(
      'gd-flavor-picker',
      class extends HTMLElement {
        connectedCallback() {
          this.onChange = (e) => {
            const input = e.target;
            if (!input.matches('input[type=radio]')) return;
            this.dispatchEvent(
              new CustomEvent('gatedrop:variant-selected', { bubbles: true, detail: { variantId: input.value } }),
            );
            const card = this.closest('.gd2-card');
            if (!card) return;
            card.querySelector('[name=id]').value = input.value;
            card
              .querySelectorAll('.gd2-card-actions>a,.gd2-title,.gd2-media')
              .forEach((a) => (a.href = input.dataset.url));
            const price = card.querySelector('.gd2-price');
            price.textContent = input.dataset.price;
            if (input.dataset.compare) {
              const strike = document.createElement('s');
              strike.textContent = input.dataset.compare;
              price.append(' ', strike);
            }
            const note = card.querySelector('.gd2-plan-note');
            if (note) {
              note.textContent = input.dataset.plan;
              note.hidden = !input.dataset.plan;
            }
          };
          this.addEventListener('change', this.onChange);
        }
        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
        }
      },
    );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-home-auto-add"] && !Shopify.designMode) return;
  try {
    if (!window.gdhAutoInstalled) {
    window.gdhAutoInstalled = true;
    // WeakMap releases removed editor sections automatically.
    const planCache = new WeakMap();
    document.addEventListener('gatedrop:variant-selected', (e) => {
      const card = e.target.closest('.gd2-card');
      if (!card) return;
      const form = card.querySelector('.gdh-auto-form');
      if (!form) return;
      let plans = planCache.get(form);
      if (!plans) {
        plans = JSON.parse(form.querySelector('[data-gdh-plans]').textContent);
        planCache.set(form, plans);
      }
      const plan = plans[String(e.detail.variantId)];
      form.elements.selling_plan.value = plan || '';
      form.querySelector('button').disabled = !plan;
    });
    // Intercept only dedicated subscription forms; never override an explicit PDP choice.
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form.matches('.gdh-auto-form')) return;
      e.preventDefault();
      if (form.dataset.busy) return;
      const error = form.querySelector('.gdh-error'),
        button = form.querySelector('button');
      error.hidden = true;
      const plan = Number(form.elements.selling_plan.value);
      if (!plan) {
        error.textContent = 'Auto-Restock is unavailable for this option.';
        error.hidden = false;
        return;
      }
      form.dataset.busy = 'true';
      button.disabled = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1, selling_plan: plan }] }),
        });
        const data = await response.json();
        if (!response.ok) throw Error(data.description || 'Unable to add this item. Please try again.');
        location.assign(root + 'cart');
      } catch (err) {
        error.textContent = err.message;
        error.hidden = false;
        button.disabled = false;
        delete form.dataset.busy;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
